module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

if((getLayoutClass() === 'side_left' || getLayoutClass() === 'side_right') && !gon.isMobile){;
__p += '\n	<div id="interactive_region"></div>\n	<div id="widget_header_wrapper" class="' +
((__t = (getLayoutClass())) == null ? '' : __t) +
'">\n		<div id="widget_header_region"></div>\n		';
 if (checkSkipContentLinks()) { ;
__p += '\n			<a class="screen_reader_only screen_reader_only_focus_visible skip_content_link" href="#carousel_end" id="carousel_start">' +
((__t = ( I18n.t('widget.screen_reader_only.carousel.skip_to_end') )) == null ? '' : __t) +
'</a>\n		';
 } ;
__p += '\n		<div aria-label="' +
((__t = ( I18n.t('widget.screen_reader_only.carousel.label') )) == null ? '' : __t) +
'" class="wrap" id="horizontal_widget" role="region">\n			<div class="controls">\n				<button class="btn prev" aria-label="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'" title="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'"></button>\n				<button class="btn next" aria-label="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'" title="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'"></button>\n			</div>\n			<div id="frame" class="horizontal_frame">\n			</div>\n		</div>\n	</div>\n';
} else { ;
__p += '\n	<div id="widget_header_region"></div>\n	<div id="interactive_region"></div>\n	';
 if (checkSkipContentLinks()) { ;
__p += '\n		<a class="screen_reader_only screen_reader_only_focus_visible skip_content_link" href="#carousel_end" id="carousel_start">' +
((__t = ( I18n.t('widget.screen_reader_only.carousel.skip_to_end') )) == null ? '' : __t) +
'</a>\n	';
 } ;
__p += '\n	<div aria-label="' +
((__t = ( I18n.t('widget.screen_reader_only.carousel.label') )) == null ? '' : __t) +
'" class="wrap" id="horizontal_widget" role="region">\n		';
 if (!gon.isMobile) { ;
__p += '\n			<div class="controls">\n				<button class="btn prev" aria-label="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'" title="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'"></button>\n				<button class="btn next" aria-label="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'" title="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'"></button>\n			</div>\n		';
 } ;
__p += '\n		<div id="frame" class="horizontal_frame">\n		</div>\n	</div>\n';
};
__p += '\n';
 if (checkSkipContentLinks()) { ;
__p += '\n	<a class="screen_reader_only screen_reader_only_focus_visible skip_content_link skip_content_link_end" href="#carousel_start" id="carousel_end">' +
((__t = ( I18n.t('widget.screen_reader_only.carousel.skip_to_beginning') )) == null ? '' : __t) +
'</a>\n';
 } ;
__p += '\n';

}
return __p
}